import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  static values = {
    maskPattern: String,
    allowForeign: Boolean,
    foreignMax: Number
  }

  connect() {
    this.boundOnSubmit = this.onSubmit.bind(this)
    this.formElement?.addEventListener("submit", this.boundOnSubmit)
    this.mascara()
  }

  disconnect() {
    this.formElement?.removeEventListener("submit", this.boundOnSubmit)
  }

  bloquearLetras(event) {
    const teclasPermitidas = [
      "Backspace", "Delete", "Tab", "Escape", "Enter",
      "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown",
      "Home", "End"
    ]

    if (event.ctrlKey || event.metaKey) return
    if (teclasPermitidas.includes(event.key)) return
    if (/^\d$/.test(event.key)) return

    event.preventDefault()
  }

  colarSoDigitos(event) {
    event.preventDefault()

    const texto = (event.clipboardData || window.clipboardData).getData("text")
    const digitos = this.soDigitos(texto).slice(0, this.maxDigits)

    this.inputTarget.value = this.aplicarMascara(digitos)
  }

  mascara() {
    const digitos = this.soDigitos(this.inputTarget.value).slice(0, this.maxDigits)
    this.inputTarget.value = this.aplicarMascara(digitos)
  }

  onSubmit() {
    this.inputTarget.value = this.soDigitos(this.inputTarget.value)
  }

  aplicarMascara(digitos) {
    // Estrangeiro: passou do tamanho BR => máscara internacional (+dígitos),
    // sem forçar o formato brasileiro (aceita qualquer comprimento até o limite).
    if (this.allowForeignValue && digitos.length > this.brDigits) {
      return "+" + digitos
    }

    const pattern = this.maskPatternValue || "(99)9999.99-99"
    let result = ""
    let digitIndex = 0

    for (let i = 0; i < pattern.length; i++) {
      const char = pattern[i]

      if (char === "9") {
        if (digitIndex >= digitos.length) break
        result += digitos[digitIndex]
        digitIndex += 1
      } else {
        if (digitIndex >= digitos.length) break
        result += char
      }
    }

    return result
  }

  soDigitos(valor) {
    return (valor || "").replace(/\D/g, "")
  }

  // Dígitos do formato BR (nº de "9" na máscara).
  get brDigits() {
    return (this.maskPatternValue || "(99)9999.99-99").replace(/[^9]/g, "").length
  }

  get maxDigits() {
    if (this.allowForeignValue) {
      return Math.max(this.brDigits, this.foreignMaxValue || 15)
    }
    return this.brDigits
  }

  get formElement() {
    return this.element.form || this.element.closest("form")
  }
}
